export default __webpack_public_path__ + "43422c18a201791ec1fcb0f635dc913f.svg";